import { i18next } from '@yola/ws-sdk';

const HIDDEN_STATE_DESCRIPTION_ICON = '{icon}';

const getWsBlockInjectedTranslations = () => {
  // The description is a single translatable sentence, but the component renders
  // an icon in the middle of it, so it is split by the icon placeholder here.
  const [hiddenStateDescriptionStart, hiddenStateDescriptionEnd = ''] = i18next
    .t('Go to {icon} in the toolbar to control the display of blocks', {
      icon: HIDDEN_STATE_DESCRIPTION_ICON,
    })
    .split(HIDDEN_STATE_DESCRIPTION_ICON);

  const [widgetHiddenStateDescriptionStart, widgetHiddenStateDescriptionEnd = ''] = i18next
    .t('Go to {icon} in the toolbar to control the display of the widget', {
      icon: HIDDEN_STATE_DESCRIPTION_ICON,
    })
    .split(HIDDEN_STATE_DESCRIPTION_ICON);

  return {
    WS_BLOCK_EMPTY_STATE_TITLE_DEFAULT: i18next.t('Empty block'),
    WS_BLOCK_EMPTY_STATE_DESCRIPTION_DEFAULT: i18next.t(
      'Go to Block Settings to control the display of elements'
    ),
    WS_BLOCK_EMPTY_STATE_TITLE_CUSTOM: i18next.t('Custom Block'),
    WS_BLOCK_EMPTY_STATE_DESCRIPTION_CUSTOM: i18next.t(
      'Press the button to add your first widget to the block'
    ),
    WS_BLOCK_EMPTY_STATE_TOOLTIP: i18next.t('Add widget'),
    WS_BLOCK_HIDDEN_STATE_TITLE: i18next.t('Hidden block'),
    WS_BLOCK_HIDDEN_STATE_DESCRIPTION_START: hiddenStateDescriptionStart.trim(),
    WS_BLOCK_HIDDEN_STATE_DESCRIPTION_END: hiddenStateDescriptionEnd.trim(),
    WS_BLOCK_HIDDEN_STATE_TITLE_WIDGET: i18next.t('Hidden widget'),
    WS_BLOCK_HIDDEN_STATE_DESCRIPTION_START_WIDGET: widgetHiddenStateDescriptionStart.trim(),
    WS_BLOCK_HIDDEN_STATE_DESCRIPTION_END_WIDGET: widgetHiddenStateDescriptionEnd.trim(),
  };
};

export default getWsBlockInjectedTranslations;
